var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 733.77 154.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-6);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 22,
    y1: 107.53,
    x2: 627.48,
    y2: 97.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#d0bdaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8bcd5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 22.02,
    y1: 108.45,
    x2: 627.49,
    y2: 98.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 22.04,
    y1: 109.69,
    x2: 627.52,
    y2: 99.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 22.06,
    y1: 111.15,
    x2: 627.54,
    y2: 100.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 22.08,
    y1: 112,
    x2: 627.55,
    y2: 101.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 22.1,
    y1: 113.29,
    x2: 627.58,
    y2: 103.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 22.1,
    y1: 113.36,
    x2: 627.58,
    y2: 103.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 22.13,
    y1: 115.37,
    x2: 627.61,
    y2: 105.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 22.15,
    y1: 116.39,
    x2: 627.63,
    y2: 106.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 21.49,
    y1: 77.57,
    x2: 626.97,
    y2: 67.35,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.66,142.4l-4.63-12.86c-.31-.87-1.14-1.45-2.06-1.45h-23.53c-.93,0-1.76.59-2.07,1.48l-4.4,12.8c-.3.88-1.13,1.48-2.07,1.48h-10.56c-1.54,0-2.6-1.55-2.03-2.99l28.69-72.96c.67-1.7,2.31-2.82,4.14-2.82h0c1.82,0,3.46,1.11,4.13,2.81l28.94,72.97c.57,1.44-.49,2.99-2.03,2.99h-10.47c-.92,0-1.74-.58-2.06-1.45ZM187.38,91.18l-8.23,25.31c-.17.52.22,1.05.76,1.05h16.47c.54,0,.93-.53.76-1.05l-8.23-25.31c-.24-.74-1.28-.74-1.52,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M279.11,142.37l-34.86-45.44c-.56-.73-1.73-.33-1.73.59v44.02c0,1.21-.98,2.19-2.19,2.19h-8.89c-1.21,0-2.19-.98-2.19-2.19v-72c0-2.46,2-4.46,4.46-4.46h0c1.37,0,2.67.63,3.51,1.71l33.64,42.98c.56.72,1.72.32,1.72-.59v-41.91c0-1.21.98-2.19,2.19-2.19h8.89c1.21,0,2.19.98,2.19,2.19v72.82c0,2.08-1.69,3.76-3.76,3.76h0c-1.17,0-2.27-.54-2.99-1.47Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M314.22,143.85h-15.05c-1.21,0-2.19-.98-2.19-2.19v-73.36c0-1.18.94-2.14,2.12-2.19,9.77-.34,15.98-.51,18.62-.51,11.32,0,20.29,3.32,26.92,9.95,6.63,6.63,9.94,15.42,9.94,26.39,0,27.93-13.45,41.9-40.36,41.9ZM310.77,79.37v50.77c0,.65.51,1.19,1.16,1.24,1.9.15,3.92.22,6.06.22,6.97,0,12.42-2.53,16.36-7.58,3.94-5.06,5.92-12.13,5.92-21.22,0-16.62-7.73-24.93-23.18-24.93-1.27,0-2.99.09-5.17.27-.64.05-1.14.59-1.14,1.24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M376.12,79.47v16.03c0,.6.48,1.08,1.08,1.08h23.14c.8,0,1.46.65,1.46,1.46v8.81c0,.8-.65,1.46-1.46,1.46h-23.14c-.6,0-1.08.48-1.08,1.08v21.13c0,.6.48,1.08,1.08,1.08h31.95c1.21,0,2.19.98,2.19,2.19v7.88c0,1.21-.98,2.19-2.19,2.19h-44.64c-1.21,0-2.19-.98-2.19-2.19v-73.33c0-1.21.98-2.19,2.19-2.19h45.22c1.21,0,2.19.98,2.19,2.19v7.88c0,1.21-.98,2.19-2.19,2.19h-32.54c-.6,0-1.08.48-1.08,1.08Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M465.6,142.85l-18.84-29.14c-.78-1.2-2.09-1.95-3.52-2l-5.2-.2c-.7-.03-1.29.54-1.29,1.24v28.92c0,1.21-.98,2.19-2.19,2.19h-9.95c-1.21,0-2.19-.98-2.19-2.19v-73.4c0-1.17.92-2.14,2.09-2.18,1.53-.06,3.82-.17,6.87-.33,5.2-.27,9.39-.4,12.57-.4,19.73,0,29.6,7.64,29.6,22.92,0,4.6-1.36,8.79-4.08,12.57-2.51,3.49-5.62,6.03-9.34,7.63-.49.21-.66.82-.37,1.27l20.17,30.74c.95,1.45-.09,3.39-1.83,3.39h-10.67c-.74,0-1.43-.38-1.84-1ZM436.76,79.3v19.2c0,.69.54,1.26,1.22,1.31,1.95.15,3.49.22,4.61.22,5.76,0,9.98-.81,12.65-2.44,2.67-1.63,4-4.79,4-9.49,0-3.82-1.43-6.49-4.3-8.01-2.86-1.52-7.37-2.28-13.52-2.28-1.12,0-2.28.06-3.47.18-.68.07-1.2.63-1.2,1.31Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M490.59,141.66v-73.33c0-1.21.98-2.19,2.19-2.19h6.23c1.21,0,2.19.98,2.19,2.19v63.34c0,1.45,1.18,2.63,2.63,2.63h30.3c1.21,0,2.19.98,2.19,2.19v5.18c0,1.21-.98,2.19-2.19,2.19h-41.35c-1.21,0-2.19-.98-2.19-2.19Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M544.16,64.81h6.23c1.21,0,2.19.98,2.19,2.19v51.02c0,4.74,1.5,8.64,4.51,11.69,3,3.06,6.98,4.59,11.93,4.59,5.23,0,9.35-1.48,12.36-4.46,3-2.97,4.51-7,4.51-12.09v-50.75c0-1.21.98-2.19,2.19-2.19h6.24c1.21,0,2.19.98,2.19,2.19v51.86c0,7.85-2.45,13.98-7.35,18.38-4.9,4.4-11.57,6.6-20.02,6.6s-15.4-2.16-20.1-6.47c-4.7-4.31-7.05-10.5-7.05-18.56v-51.81c0-1.21.98-2.19,2.19-2.19Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M654.49,142.81l-17.74-28.65c-.42-.68-1.41-.66-1.81.03l-16.31,28.55c-.39.68-1.11,1.1-1.9,1.1h-5.69c-1.68,0-2.73-1.81-1.9-3.27l20.45-35.97c.38-.67.38-1.48,0-2.15l-18.61-33.09c-.82-1.46.24-3.27,1.92-3.26l5.42.03c.78,0,1.51.43,1.89,1.11l15.1,26.73c.39.7,1.39.72,1.81.04l16.72-26.85c.4-.64,1.1-1.03,1.86-1.03h5.45c1.73,0,2.77,1.91,1.84,3.37l-21.22,33.07c-.46.72-.46,1.63,0,2.35l22.49,35.57c.92,1.46-.13,3.36-1.85,3.36h-6.06c-.76,0-1.46-.39-1.86-1.04Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M684.87,77.88v19.4h23.49c1.21,0,2.19.98,2.19,2.19v4.65c0,1.21-.98,2.19-2.19,2.19h-23.49v25.82c0,1.21.98,2.19,2.19,2.19h30.85c1.21,0,2.19.98,2.19,2.19v5.18c0,1.21-.98,2.19-2.19,2.19h-41.45c-1.21,0-2.19-.98-2.19-2.19v-73.33c0-1.21.98-2.19,2.19-2.19h42.04c1.21,0,2.19.98,2.19,2.19v5.18c0,1.21-.98,2.19-2.19,2.19h-31.43c-1.21,0-2.19.98-2.19,2.19Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.16,8.21c-.24-1.16-1.46-1.86-1.87-1.9-.47-.12-.76-.11-.95-.1-.22,0-.35.03-.49.05-.54.11-.63.16-.88.23,0,0-2.61.76-2.61.76-51.01,15.4-75.77,64.71-90.75,111.99-.25.73-1.26.9-1.74.27,0,0-1.82-1.94-1.82-1.94-2.3-2.43-8.66-8.99-11.06-11.47-4.31-4.5-10.54-10.81-14.72-15.31-.27-.29-1.05-1.14-1.29-1.44-1.36-1.6-4.03-1.72-5.54-.3-8.2,8.27-16.58,16.41-24.2,25.23-.09.14-.25.24-.42.22-.03-.06-.12-.27-.12-.27,0,0-.27-.62-.27-.62-6.54-15.4-17.39-28.97-31.17-38.5-8.33-5.56-17.72-10.33-27.88-11.11l-.36-.02c-.27.01.34-.04-.64.03-1.76.4-2.53,2.49-1.72,4.01.25.52.9,1.04,1.44,1.18,0,0,.64.19.64.19,13.16,4.11,23.65,14.4,32.35,24.89,6.64,8.17,12.51,17.04,17.61,26.27l2.57,4.72c.58.9,1.48,1.59,2.49,1.93.75.33,2.16.24,2.9.24,0,0,5.31-.04,5.31-.04,1.55.04,3.15-.8,4.02-2.1,4.26-6.18,8.67-12.28,13.21-18.26,2.13-2.73,4.22-5.64,6.66-8.08.36-.39.86-.38,1.22,0l1.52,2.06,3.1,4.3c8.19,11.56,15.82,23.48,23.86,35.16l.77,1.1c.07.1.17.24.25.34.76.95,2,1.48,3.18,1.48l1.33.02c.84.03,3.19.02,3.98.06.62.02,1.28.02,1.87-.21,1.37-.45,2.24-1.76,2.51-3.13,1.64-5.82,3.39-12.08,5.05-17.87,11.23-40.08,29.31-80.8,66.44-102.94,4.33-2.67,8.76-5.06,13.45-6.97.94-.38,1.74-1,2.31-1.82.1-.15.2-.3.33-.6.09-.29.34-.69.14-1.72ZM71.8,114.49s-.04-.02,0,0h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWlLogo);
export default __webpack_public_path__ + "static/media/WL_LOGO.a2aba48b5daecd4bb8cc326151c963b9.svg";
export { ForwardRef as ReactComponent };